// Contact Information
export const PHONE_NUMBER = '+393318857252';
export const WHATSAPP_NUMBER = '393318857252';
export const INSTAGRAM_URL = 'https://www.instagram.com/rogers_club_barberia';
export const VAT_NUMBER = '07183440481';

// Address
export const ADDRESS = {
  street: 'Via Tanzini, 41',
  city: 'Pontassieve',
  province: 'FI',
  postalCode: '50065',
  full: 'Via Tanzini, 41, 50065 Pontassieve (FI)'
};

// Opening Hours
export const OPENING_HOURS = [
  { day: 'Lunedì', hours: 'Chiuso', closed: true },
  { day: 'Martedì', hours: '09:00-13:00, 15:30-19:30', closed: false },
  { day: 'Mercoledì', hours: '09:00-13:00, 15:30-19:30', closed: false },
  { day: 'Giovedì', hours: '09:00-13:00, 15:30-19:30', closed: false },
  { day: 'Venerdì', hours: '09:00-13:00, 15:30-19:30', closed: false },
  { day: 'Sabato', hours: '09:00-13:00, 15:30-19:30', closed: false },
  { day: 'Domenica', hours: 'Chiuso', closed: true }
];

// Gallery Images
export const GALLERY_IMAGES = [
  // Foto originali
  'https://customer-assets.emergentagent.com/job_rogers-club/artifacts/4xv4eat3_WhatsApp%20Image%202026-01-26%20at%2022.37.18-2.jpeg',
  'https://customer-assets.emergentagent.com/job_rogers-club/artifacts/psmi1ghc_WhatsApp%20Image%202026-01-26%20at%2022.37.18-3.jpeg',
  'https://customer-assets.emergentagent.com/job_rogers-club/artifacts/3t0fmipe_WhatsApp%20Image%202026-01-26%20at%2022.37.18.jpeg',
  'https://customer-assets.emergentagent.com/job_rogers-club/artifacts/e11bcown_WhatsApp%20Image%202026-01-26%20at%2022.37.19-2.jpeg',
  'https://customer-assets.emergentagent.com/job_rogers-club/artifacts/aypgy13r_WhatsApp%20Image%202026-01-26%20at%2022.37.19-3.jpeg',
  // Nuove foto
  'https://customer-assets.emergentagent.com/job_eef2a58b-2345-4e6e-8719-3357e7caaa27/artifacts/p0pzkx7x_WhatsApp%20Image%202026-02-14%20at%2020.09.41.jpeg',
  'https://customer-assets.emergentagent.com/job_eef2a58b-2345-4e6e-8719-3357e7caaa27/artifacts/bzcv2geh_WhatsApp%20Image%202026-02-14%20at%2020.09.25.jpeg',
  'https://customer-assets.emergentagent.com/job_eef2a58b-2345-4e6e-8719-3357e7caaa27/artifacts/s73a2vrh_WhatsApp%20Image%202026-02-14%20at%2020.09.25-3.jpeg',
  'https://customer-assets.emergentagent.com/job_eef2a58b-2345-4e6e-8719-3357e7caaa27/artifacts/d7dddvul_WhatsApp%20Image%202026-02-14%20at%2020.09.25-2.jpeg',
  'https://customer-assets.emergentagent.com/job_eef2a58b-2345-4e6e-8719-3357e7caaa27/artifacts/6mjwaim8_WhatsApp%20Image%202026-02-14%20at%2020.09.24.jpeg',
  // Ultime foto aggiunte
  'https://customer-assets.emergentagent.com/job_eef2a58b-2345-4e6e-8719-3357e7caaa27/artifacts/3hck5gb1_WhatsApp%20Image%202026-02-14%20at%2020.35.27.jpeg',
  'https://customer-assets.emergentagent.com/job_eef2a58b-2345-4e6e-8719-3357e7caaa27/artifacts/9erkhuox_WhatsApp%20Image%202026-02-14%20at%2020.35.24.jpeg'
];

// Google Maps
export const GOOGLE_MAPS_URL = 'https://www.google.com/maps/place/Roger\'s+Club+Barberia/@43.7715695,11.4318628,17z';
export const GOOGLE_MAPS_EMBED_URL = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2876.893574265834!2d11.431862776542183!3d43.771569471096794!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132a56c7b1b1b1b1%3A0x1b1b1b1b1b1b1b1b!2sVia%20Tanzini%2C%2041%2C%2050065%20Pontassieve%20FI%2C%20Italy!5e0!3m2!1sen!2sit!4v1706000000000!5m2!1sen!2sit';
